import { render, staticRenderFns } from "./password-forgot.vue?vue&type=template&id=222147b6"
import script from "./password-forgot.vue?vue&type=script&lang=js"
export * from "./password-forgot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./password-forgot.vue?vue&type=custom&index=0&blockType=router"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ArrowLeftIcon: require('/vercel/path0/components/icons/ArrowLeftIcon.vue').default,AppLink: require('/vercel/path0/components/shared/AppLink.vue').default,SpinIcon: require('/vercel/path0/components/icons/SpinIcon.vue').default,CornerIcon: require('/vercel/path0/components/icons/CornerIcon.vue').default,ContainerContent: require('/vercel/path0/components/shared/ContainerContent.vue').default})
